var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionWeek(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.5H9.5V1C9.5 0.867392 9.44732 0.740215 9.35355 0.646447C9.25979 0.552678 9.13261 0.5 9 0.5C8.86739 0.5 8.74021 0.552678 8.64645 0.646447C8.55268 0.740215 8.5 0.867392 8.5 1V1.5H3.5V1C3.5 0.867392 3.44732 0.740215 3.35355 0.646447C3.25979 0.552678 3.13261 0.5 3 0.5C2.86739 0.5 2.74021 0.552678 2.64645 0.646447C2.55268 0.740215 2.5 0.867392 2.5 1V1.5H1.5C1.23478 1.5 0.98043 1.60536 0.792893 1.79289C0.605357 1.98043 0.5 2.23478 0.5 2.5V10.5C0.5 10.7652 0.605357 11.0196 0.792893 11.2071C0.98043 11.3946 1.23478 11.5 1.5 11.5H10.5C10.7652 11.5 11.0196 11.3946 11.2071 11.2071C11.3946 11.0196 11.5 10.7652 11.5 10.5V2.5C11.5 2.23478 11.3946 1.98043 11.2071 1.79289C11.0196 1.60536 10.7652 1.5 10.5 1.5ZM10.5 10.5H1.5V4.5H10.5V10.5ZM3.5 6.5H2.5V5.5H3.5V6.5ZM6.5 6.5H5.5V5.5H6.5V6.5ZM9.5 6.5H8.5V5.5H9.5V6.5ZM3.5 8.5H2.5V7.5H3.5V8.5ZM6.5 8.5H5.5V7.5H6.5V8.5ZM9.5 8.5H8.5V7.5H9.5V8.5Z",
    fill: "#95D5B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionWeek);
export default __webpack_public_path__ + "static/media/action_week.5ad102ad6c387fd4d0a67fa08544a773.svg";
export { ForwardRef as ReactComponent };